<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">


      <a-form-model-item prop="theme" >
        <span slot="label" >
        <a-tooltip>
        {{$t('直播主题')}}<template slot="title">{{$t('直播主题')}}</template>
        </a-tooltip>
        </span>
        <a-input v-model="form.theme" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('直播主题')"/>
      </a-form-model-item>




        <a-form-model-item prop="liveAddress" >
        <span slot="label" >
          <a-tooltip>
            {{$t('地址')}}<template slot="title">{{$t('地址')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.liveAddress" :placeholder="$t('通用.输入.请输入')+$t('地址')" />
      </a-form-model-item>

            <a-form-model-item prop="preOpenTime" >
              <span slot="label" >
                <a-tooltip>
                  {{$t('直播预计开启时间')}}<template slot="title">{{$t('直播预计开启时间')}}</template>
                </a-tooltip>
              </span>
              <a-date-picker
                style="width: 100%"
                v-model="form.preOpenTime"
                value-format="YYYY-MM-DD HH:mm:ss"
                show-time
                allow-clear
                :disabled-date="disabledPreOpenDate"
                :disabled-time="disabledPreOpenTime"
                @change="handlePreOpenTimeChange"/>
            </a-form-model-item>
        <a-row :gutter="48">
            <a-col :md="12" :sm="24">
      <a-form-model-item :label="this.$t('直播封面')" prop="thumb">
        <a-upload
          name="thumb"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.thumb"
            :src="form.thumb"
            alt="picture"
            style="height: 100px; width: 100px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
          </div>
        </a-upload>
        <span>推荐尺寸 100 x 100</span>
      </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
        <a-form-model-item :label="this.$t('分享直播封面')" prop="sharePic">
            <a-upload
                    name="sharePic"
                    listType="picture-card"
                    :multiple="false"
                    :show-upload-list="false"
                    :preview="handlePreview"
                    :before-upload="beforeOssUploadSharePic"
                    :customRequest="coverImgUploadSharePic">
                <img
                        v-if="form.sharePic"
                        :src="form.sharePic"
                        alt="picture"
                        style="height: 100px; width: 100px;"/>
                <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'"/>
                    <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
                </div>
            </a-upload>
            <span>20K以内的图片</span>
        </a-form-model-item>
            </a-col>
        </a-row>


      <a-form-model-item prop="liveType" >
            <span slot="label" >
              <a-tooltip>
                {{$t('直播类型')}}<template slot="title">{{$t('直播类型')}}</template>
              </a-tooltip>
            </span>
        <a-select v-model="form.liveType" placeholder="请选择类型">
          <a-select-option v-for="(item, index) in liveTypeList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item prop="screenMode" >
            <span slot="label" >
              <a-tooltip>
                {{$t('屏幕模式')}}<template slot="title">{{$t('屏幕模式')}}</template>
              </a-tooltip>
            </span>
        <a-select v-model="form.screenMode" placeholder="请选择类型">
          <a-select-option v-for="(item, index) in screenModeList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="allowUserId" v-if="form.liveType==2">
            <span slot="label" >
              <a-tooltip>
                {{$t('允许开播用户')}}<template slot="title">{{$t('允许开播用户')}}</template>
              </a-tooltip>
            </span>
          <a-select v-model="form.allowUserId" show-search placeholder="请选择用户" :filter-option="filterUserOption">
            <a-select-option v-for="(item, index) in userList" :value="item.id" :key="index" :title="item.nickName + ' ' + item.mobile">
              {{ item.nickName+' '+item.mobile }}
            </a-select-option>
          </a-select>
      </a-form-model-item>


        <a-form-model-item prop="manageUserId"  v-if="form.liveType==3">
            <span slot="label" >
              <a-tooltip>
                {{$t('管理员')}}<template slot="title">{{$t('管理员')}}</template>
              </a-tooltip>
            </span>
            <a-select v-model="form.manageUserId" placeholder="请选择用户">
                <a-select-option v-for="(item, index) in userList"  :value="item.id" :key="index">
                    {{ item.nickName+' '+item.mobile }}
                </a-select-option>
            </a-select>
        </a-form-model-item>

      <a-form-model-item prop="isPlayback" >
            <span slot="label" >
              <a-tooltip>
                {{$t('是否可以回放')}}<template slot="title">{{$t('是否可以回放')}}</template>
              </a-tooltip>
            </span>
        <a-select v-model="form.isPlayback" placeholder="请选择">
          <a-select-option v-for="(item, index) in signList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item prop="showSignFlag" >
            <span slot="label" >
              <a-tooltip>
                {{$t('是否可以签到')}}<template slot="title">{{$t('是否可以签到')}}</template>
              </a-tooltip>
            </span>
        <a-select v-model="form.showSignFlag" placeholder="请选择">
          <a-select-option v-for="(item, index) in signList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="pubSignType" v-if="form.showSignFlag==1 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('签到奖励类型')}}<template slot="title">{{$t('签到奖励类型')}}</template>
        </a-tooltip>
        </span>
        <a-select v-model="form.pubSignType" :placeholder="$t('通用.输入.请选择')+$t('签到奖励类型')">
          <a-select-option v-for="item in signTypeList" :value="item.value" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="pubSignNum" v-if="form.showSignFlag==1 && form.pubSignType==1 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('签到获取积分')}}<template slot="title">{{$t('签到获取积分')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.pubSignNum" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('签到获取积分')"/>
      </a-form-model-item>
      <a-form-model-item prop="pubSignMoney" v-if="form.showSignFlag==1 && form.pubSignType==2 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('签到发放红包金额')}}<template slot="title">{{$t('签到发放红包金额')}}</template>
        </a-tooltip>
        </span>
        <a-input-number
          v-model="form.pubSignMoney"
          :min="0"
          :max="99999"
          :step="0.01"
          :precision="2"
          style="width: 100%"
          :placeholder="$t('通用.输入.请输入')+$t('签到发放红包金额')"/>
      </a-form-model-item>
      <a-form-model-item prop="pubSignCouponId" v-if="form.showSignFlag==1 && form.pubSignType==3 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('签到发放优惠券')}}<template slot="title">{{$t('签到发放优惠券')}}</template>
        </a-tooltip>
        </span>
        <a-select v-model="form.pubSignCouponId" allowClear :placeholder="$t('通用.输入.请选择')+$t('签到发放优惠券')">
          <a-select-option v-for="item in signCouponList" :value="item.id" :key="item.id">
            {{ item.couponName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="pubSignTime" v-if="form.showSignFlag==1 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('观看多长时间可签到（分钟）')}}<template slot="title">{{$t('观看多长时间可签到（分钟）')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.pubSignTime" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('观看多长时间可签到')"/>
      </a-form-model-item>

    <a-form-model-item prop="receiptTime" >
        <span slot="label" >
        <a-tooltip>
        {{$t('观看直播回执（分钟）')}}<template slot="title">{{$t('观看直播回执（分钟）')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.receiptTime" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('观看直播回执（分钟）')"/>
      </a-form-model-item>
      <a-form-model-item prop="receiptTime" v-if="form.receiptTime&&form.receiptTime>0">
        <span slot="label" >
        <a-tooltip>
        {{$t('直播确认弹窗倒计时(秒)')}}<template slot="title">{{$t('直播确认弹窗倒计时(秒)')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.receiptEffectiveTime" :max="99999" :min="10" :placeholder="$t('通用.输入.请输入')+$t('观看直播回执（分钟）')"/>
      </a-form-model-item>


      <a-form-model-item prop="password" >
        <span slot="label" >
        <a-tooltip>
        {{$t('密码')}}<template slot="title">{{$t('密码')}}</template>
        </a-tooltip>
        </span>
        <a-input v-model="form.password" :maxLength="6" :placeholder="$t('通用.输入.请输入')+$t('直播密码')"/>
      </a-form-model-item>












      <!--选择商品-->
      <a-form-model-item :label="$t('通用.文本.选择商品')" prop="goodsId">
        <a-space>
          <a-button type="dashed" @click="openProdSelect" danger>
            <span style="color: dodgerblue"> 选择秒杀商品</span>
          </a-button>
          <a-button type="dashed" @click="openNormalProdSelect">
            <span style="color: dodgerblue"> 选择普通商品</span>
          </a-button>
        </a-space>
      </a-form-model-item>
      <!-- 数据展示 -->
      <a-table
        :loading="goodsLoading"
        :scroll="{ x: '100%' }"
        :rowKey="goodsRowKey"
        :size="tableSize"
        :columns="goodsColumns"
        :data-source="selectedGoods"
        :pagination="false"
        :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.goodsPicture || record.picture" :src="record.goodsPicture || record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.goodsPicture || record.picture)" alt="none"/>
          </div>
        </template>

<!--        <span slot="categoryId" slot-scope="text, record">-->
<!--            {{getCategoryNameById(record.categoryId)}}-->
<!--        </span>-->
        <span slot="brandId" slot-scope="text, record">
             {{getBrandNameById(record.brandId)}}
          </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
          </span>
        <span slot="goodsType" slot-scope="text, record">
          <a-tag v-if="record.goodsType" :color="record.goodsType === 'normal' ? 'blue' : 'red'">{{ record.goodsType === 'normal' ? '普通' : '秒杀' }}</a-tag>
        </span>
        <span slot="goodsPrice" slot-scope="text, record">
          {{ record.goodsType === 'normal' ? record.price : record.seckillPrice }}
        </span>
      </a-table>

      <!--选择商品-->

      <!--<a-form-model-item prop="signScore" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('直播签到获取积分')}}<template slot="title">{{$t('直播签到获取积分')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input v-model="form.signScore" @change="limitPrice()" :placeholder="$t('通用.输入.请输入')+$t('直播签到获取积分')"/>-->
      <!--</a-form-model-item>-->

      <a-form-model-item prop="seekInter" v-if="formType == 2">
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间观看间隔时长')}}<template slot="title">{{$t('直播间观看间隔时长')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.seekInter" :placeholder="$t('通用.输入.请输入')+$t('直播间观看间隔时长')"/>
      </a-form-model-item>

      <!--<a-form-model-item prop="signShowTime" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('直播签到显示时长(分钟)')}}<template slot="title">{{$t('直播签到显示时长(分钟)')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input-number v-model="form.signShowTime" :placeholder="$t('通用.输入.请输入')+$t('直播签到显示时长(分钟)')"/>-->
      <!--</a-form-model-item>-->
      <a-form-model-item prop="seekScore"  v-if="formType == 2">
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间观看获取积分')}}<template slot="title">{{$t('直播间观看获取积分')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.seekScore" @change="limitPrice1()" :placeholder="$t('通用.输入.请输入')+$t('直播间观看获取积分')"/>
      </a-form-model-item>

      <a-form-model-item prop="bitRate"  v-if="formType == 2">
        <span slot="label" >
          <a-tooltip>
            {{$t('码率')}}<template slot="title">{{$t('码率')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.bitRate" @change="limitbitRate()" :placeholder="$t('通用.输入.请输入')+$t('码率')"/>
      </a-form-model-item>

      <a-form-model-item prop="userShare"  v-if="formType == 2">
        <span slot="label" >
          <a-tooltip>
            {{$t('是否允许普通用户分享')}}<template slot="title">{{$t('是否允许普通用户分享')}}</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('通用.输入.请选择')+$t('是否允许普通用户分享')" v-model="form.userShare" allowClear>
          <a-select-option  :value="0">{{$t('否')}}</a-select-option>
          <a-select-option  :value="1">{{$t('是')}}</a-select-option>
        </a-select>
      </a-form-model-item>

<!--      <a-form-model-item prop="imGroupId" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('腾讯IM群ID(发起直播单独创建一个群)')}}<template slot="title">{{$t('腾讯IM群ID(发起直播单独创建一个群)')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.imGroupId" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('腾讯IM群ID(发起直播单独创建一个群)')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="userId" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播用户id')}}<template slot="title">{{$t('直播用户id')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+$t('直播用户id')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="shopId" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播商户id')}}<template slot="title">{{$t('直播商户id')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.shopId"  :placeholder="$t('通用.输入.请输入')+$t('直播商户id')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="shopName" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播人昵称')}}<template slot="title">{{$t('直播人昵称')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.shopName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('直播人昵称')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="shopLogo" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播人头像')}}<template slot="title">{{$t('直播人头像')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.shopLogo" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('直播人头像')" />-->
<!--      </a-form-model-item>-->


<!--      <a-form-model-item prop="intro" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播主题介绍')}}<template slot="title">{{$t('直播主题介绍')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.intro" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="liveName" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播间名称(推流名称)')}}<template slot="title">{{$t('直播间名称(推流名称)')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.liveName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('直播间名称(推流名称)')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="openTime" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播开启时间')}}<template slot="title">{{$t('直播开启时间')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-date-picker style="width: 100%" v-model="form.openTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="closeTime" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播关闭时间(前端点击关播时间,或者定时任务扫描到没有推流了)')}}<template slot="title">{{$t('直播关闭时间(前端点击关播时间,或者定时任务扫描到没有推流了)')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-date-picker style="width: 100%" v-model="form.closeTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="expiredTime" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('推流过期时间')}}<template slot="title">{{$t('推流过期时间')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-date-picker style="width: 100%" v-model="form.expiredTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="effective" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播有效时长(单位:小时)')}}<template slot="title">{{$t('直播有效时长(单位:小时)')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.effective"  :placeholder="$t('通用.输入.请输入')+$t('直播有效时长(单位:小时)')" />-->
<!--      </a-form-model-item>-->
      <!--<a-form-model-item prop="duration" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('直播时长(秒)')}}<template slot="title">{{$t('直播时长(秒)')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input-number v-model="form.duration"  :placeholder="$t('通用.输入.请输入')+$t('直播时长')" disabled="true"/>-->
      <!--</a-form-model-item>-->
<!--      <a-form-model-item prop="pushUrl" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('推流地址')}}<template slot="title">{{$t('推流地址')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.pushUrl" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="pullUrl" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('拉流地址')}}<template slot="title">{{$t('拉流地址')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.pullUrl" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <!--<a-form-model-item prop="chatNum" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('直播互动人数(峰值)')}}<template slot="title">{{$t('直播互动人数(峰值)')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input-number v-model="form.chatNum"  :placeholder="$t('通用.输入.请输入')+$t('直播互动人数(峰值)')" disabled="true"/>-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item prop="totalMoney" >-->
        <!--<span slot="label" >-->
          <!--<a-tooltip>-->
            <!--{{$t('直播累计收益 ')}}<template slot="title">{{$t('直播累计收益 ')}}</template>-->
          <!--</a-tooltip>-->
        <!--</span>-->
        <!--<a-input-number v-model="form.totalMoney"  :placeholder="$t('通用.输入.请输入')+$t('直播累计收益 ')" disabled="true"/>-->
      <!--</a-form-model-item>-->
<!--      <a-form-model-item prop="status" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播状态 1:推流地址生成(未开播) 2:已开播 3:直播结束')}}<template slot="title">{{$t('直播状态 1:推流地址生成(未开播) 2:已开播 3:直播结束')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="cutInfo" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('断流信息(直播断流总信息)')}}<template slot="title">{{$t('断流信息(直播断流总信息)')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.cutInfo" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="isErrorClose" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('是否直播流异常,1,异常 0,正常,腾讯云直播流异常时写入')}}<template slot="title">{{$t('是否直播流异常,1,异常 0,正常,腾讯云直播流异常时写入')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.isErrorClose"  :placeholder="$t('通用.输入.请输入')+$t('是否直播流异常,1,异常 0,正常,腾讯云直播流异常时写入')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="errorCloseTime" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('异常时间')}}<template slot="title">{{$t('异常时间')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-date-picker style="width: 100%" v-model="form.errorCloseTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="classifyId" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播分类,live_live_classify')}}<template slot="title">{{$t('直播分类,live_live_classify')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.classifyId" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('直播分类,live_live_classify')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="liveType" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播类型 (1:语音直播,2:视频直播)')}}<template slot="title">{{$t('直播类型 (1:语音直播,2:视频直播)')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--      </a-form-model-item>-->

<!--      <a-form-model-item prop="liveCityName" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('直播城市')}}<template slot="title">{{$t('直播城市')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.liveCityName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('直播城市')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="redPacketExpiredTime" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('红包过期时间')}}<template slot="title">{{$t('红包过期时间')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-date-picker style="width: 100%" v-model="form.redPacketExpiredTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="redPacketBeginTime" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('红包开始领取时间')}}<template slot="title">{{$t('红包开始领取时间')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-date-picker style="width: 100%" v-model="form.redPacketBeginTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="remark" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <!--<a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">-->
        <!--<img alt="example" style="width: 100%" :src="previewUrl" />-->
      <!--</a-modal>-->
      <!--<a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">-->
        <!--<video style="width: 100%" :src="previewUrl" ref="myVideo"-->
               <!--:poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>-->
      <!--</a-modal>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>


      <!--选择商品-->
      <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>
      <!--选择商品-->
      <!--选择普通商品-->
      <normal-goods-select-form ref="NormalGoodsSelectForm" @goodsSelect="normalGoodsModalSelect"></normal-goods-select-form>
      <!--选择普通商品-->

    </a-form-model>
  </a-drawer>
</template>

<script>
import {getLive, addLive, updateLive, shopUserList, userList, getLiveGoods, addLiveGoods, addSeckillGoodsToLiveRoom} from '@/api/live/live'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
import {listCouponType} from "@/api/coupon/couponType";

//选择商品
import RadioGoodsSelectForm from "@/views/live/live/modules/GoodsSelectForm";
//选择普通商品
import NormalGoodsSelectForm from "@/views/goods/goods/modules/RadioSelectForm";
import {allBrand} from "@/api/goods/brand";
import moment from 'moment';
//选择商品

export default {
  name: 'CreateFormLive',
  props: {
  },
  components: {
    CustomDictTag,
    //选择商品
    RadioGoodsSelectForm,
    //选择商品
    //选择普通商品
    NormalGoodsSelectForm
    //选择普通商品
  },
  data () {
    return {
      shopUserList:[],
      liveTypeList:[

          {
            value: 2,
            label: this.$t('视频直播')
          },
        {
          value: 3,
          label: this.$t('obs直播')
        },
      ], screenModeList:[
          {
            value: 1,
            label: this.$t('竖屏')
          },
        {
          value: 2,
          label: this.$t('横屏')
        },
      ],
      signList:[
        {
          value: 0,
          label: this.$t('否')
        },
        {
          value: 1,
          label: this.$t('是')
        },

      ],
      // 签到奖励类型 1积分 2红包 3优惠券
      signTypeList: [
        {
          value: 1,
          label: this.$t('积分')
        },
        {
          value: 2,
          label: this.$t('红包')
        },
        {
          value: 3,
          label: this.$t('优惠券')
        },
      ],
        userList:[],
      // 签到可发放的优惠券
      signCouponList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 直播预计开启时间选择的日期，用于限制时间只能选当前时间之后
      preOpenDate: null,

      //选择商品
      categoryList:[],
      goodsColumns: [
        /*{
          title: this.$t('商品.商品编号'),
          dataIndex: 'goodsCode',
          width: 100,
          fixed: 'left',
        },*/
        {
          title: this.$t('商品.商品名称'),
          dataIndex: 'goodsName',
        },
        {
          title: this.$t('商品.商品主图'),
          dataIndex: 'goodsPicture',
          scopedSlots: {customRender: 'picture'},
        },
        // {
        //   title: this.$t('商品.商品分类'),
        //   dataIndex: 'categoryId',
        //   width: 60,
        //   scopedSlots: {customRender: 'categoryId'},
        // },
        // {
        //   title: this.$t('商品.品牌'),
        //   dataIndex: 'brandId',
        //   width: 50,
        //   scopedSlots: {customRender: 'brandId'},
        // },
        // {
        //   title: this.$t('商品.市场价'),
        //   width: 50,
        //   dataIndex: 'marketPrice',
        // },
        {
          title: this.$t('秒杀价'),
          dataIndex: 'seckillPrice',
          scopedSlots: {customRender: 'goodsPrice'},
        },
        {
          title: '商品类型',
          dataIndex: 'goodsType',
          width: 80,
          scopedSlots: {customRender: 'goodsType'},
        },
      ],
      //选择商品

      // 表单参数
      form: {
        //选择商品
        goodsList: [],
        //选择的普通商品
        normalGoodsList: [],
        //选择商品

        id: null,

        imGroupId: null,

        userId: null,

        shopId: null,

        shopName: null,

        shopLogo: null,

        thumb: null,
          sharePic: null,

        theme: null,

        intro: null,

        liveName: null,

        openTime: null,
        preOpenTime: null,

        closeTime: null,

        expiredTime: null,

        effective: null,

        duration: null,

        pushUrl: null,

        pullUrl: null,

        chatNum: null,

        totalMoney: null,

        status: 0,

        cutInfo: null,

        isErrorClose: null,

        errorCloseTime: null,

        classifyId: null,

        liveType: 2,
        screenMode: 1,
        showSignFlag: 0,
        isPlayback: 0,
        pubSignNum: 1,
        pubSignType: 1,
        pubSignMoney: 0,
        pubSignCouponId: null,
        pubSignTime: 1,
        receiptTime: 1,
        receiptEffectiveTime:10,
        liveAddress: null,

        liveCityName: null,

        redPacketExpiredTime: null,

        redPacketBeginTime: null,

        createTime: null,

        remark: null,
        signInter:null,
        signScore:null,
        seekInter:null,
        seekScore:null,
        userShare:null,
        signShowTime:null,
        signNum:null,
        liveScreen:null,
        bitRate:null,
        flow:null,
        allowUserId:null,
        manageUserId:null,
        password:null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        imGroupId: [
          { required: true, message: this.$t('腾讯IM群ID(发起直播单独创建一个群)')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        theme: [
          { required: true, message: this.$t('直播主题')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],  thumb: [
          { required: true, message: this.$t('直播封面')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        isErrorClose: [
          { required: true, message: this.$t('是否直播流异常,1,异常 0,正常,腾讯云直播流异常时写入')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], pubSignTime: [
          { required: true, message: this.$t('请填写')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], liveType: [
          { required: true, message: this.$t('直播类型')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], allowUserId: [
          { required: true, message: this.$t('开播用户')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],manageUserId: [
          { required: true, message: this.$t('管理员')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],pubSignNum: [
          { required: true, message: this.$t('签到获取积分')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        liveScreen:[
          { required: true, message: this.$t('直播主题')+this.$t('通用.输入.请选择'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    //选择商品
    // this.getCateList();
    // this.getBrandList();
    //选择商品

    this.getShopUserList();
    this.getUserList();
    this.getSignCouponList();
  },
  computed: {
    ...mapGetters(['customDict']),
    // 已选商品（秒杀商品 + 普通商品）
    selectedGoods() {
      return (this.form.goodsList || []).concat(this.form.normalGoodsList || [])
    },
    // 表格行key（秒杀商品id与普通商品id可能重复，按类型区分）
    goodsRowKey(record) {
      return (record.goodsType || 'live') + '-' + record.id
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // 禁用今天之前的日期
    disabledPreOpenDate(current) {
      if (!current) {
        return false
      }
      return moment(current).endOf('day').valueOf() < moment().valueOf()
    },
    // 选今天时禁用已经过去的时刻，选未来日期则不限制
    disabledPreOpenTime() {
      const now = moment()
      if (this.preOpenDate && this.preOpenDate !== now.format('YYYY-MM-DD')) {
        return {}
      }
      const hour = now.hours()
      const minute = now.minutes()
      const second = now.seconds()
      return {
        disabledHours: () => {
          const hours = []
          for (let i = 0; i < hour; i++) {
            hours.push(i)
          }
          return hours
        },
        disabledMinutes: (h) => {
          const minutes = []
          if (h === hour) {
            for (let i = 0; i < minute; i++) {
              minutes.push(i)
            }
          }
          return minutes
        },
        disabledSeconds: (h, m) => {
          const seconds = []
          if (h === hour && m === minute) {
            for (let i = 0; i < second; i++) {
              seconds.push(i)
            }
          }
          return seconds
        }
      }
    },
    // 记录已选择的日期
    handlePreOpenTimeChange(date, dateString) {
      let value = typeof dateString === 'string' ? dateString : ''
      if (!value && date && date.format) {
        value = date.format('YYYY-MM-DD HH:mm:ss')
      }
      this.preOpenDate = value ? value.substring(0, 10) : null
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.preOpenDate = null
      this.form = {
        //选择商品
        goodsList: [],
        //选择的普通商品
        normalGoodsList: [],
        //选择商品
        id: null,
        imGroupId: null,
        userId: null,
        shopId: null,
        shopName: null,
        shopLogo: null,
        thumb: null,
          sharePic: null,
        theme: null,
        intro: null,
        liveName: null,
        openTime: null,
        preOpenTime: null,
        closeTime: null,
        expiredTime: null,
        effective: null,
        duration: null,
        pushUrl: null,
        pullUrl: null,
        chatNum: null,
        totalMoney: null,
        status: 0,
        cutInfo: null,
        isErrorClose: null,
        errorCloseTime: null,
        classifyId: null,
        liveType: 2,
        screenMode: 1,
        showSignFlag: 0,
        isPlayback: 0,
        pubSignNum: 1,
        pubSignType: 1,
        pubSignMoney: 0,
        pubSignCouponId: null,
        pubSignTime: 1,
        receiptTime: 1,
        receiptEffectiveTime:10,
        liveAddress: null,
        liveCityName: null,
        redPacketExpiredTime: null,
        redPacketBeginTime: null,
        createTime: null,
        remark: null,
        signInter:null,
        signScore:null,
        seekInter:null,
        seekScore:null,
        userShare:null,
        signShowTime:null,
        signNum:null,
        liveScreen:null,
        bitRate:null,
        flow:null,
        allowUserId:null,
        manageUserId:null,
        password:null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      //查询店铺用户
      this.getShopUserList();
      this.getUserList();


      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLive({"id":id}).then(response => {
        this.form = response.data
        this.$set(this.form, 'goodsList', [])
        this.$set(this.form, 'normalGoodsList', [])
        // 加载直播商品列表
        getLiveGoods({"id": id}).then(res => {
          this.form.goodsList = res.data || []
        })
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.preOpenTime && moment(this.form.preOpenTime).isBefore(moment())) {
            this.$message.error('直播预计开启时间不能早于当前时间')
            return false
          }
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateLive(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.新增成功')
            // 秒杀商品ID列表
            const seckillIds = (this.form.goodsList || []).map(e => e.id)
            // 普通商品，后端只取商品ID
            const goodsList = (this.form.normalGoodsList || []).map(e => ({id: e.id}))
            const param = Object.assign({}, this.form, {seckillIds: seckillIds, goodsList: goodsList})
            addLive(param).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    limitPrice() {
      // console.log(i);
      let val = this.form.signScore.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.signScore = val
    },
    limitPrice1() {
      // console.log(i);
      let val = this.form.seekScore.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.seekScore = val
    },

    limitbitRate() {
      // console.log(i);
      let val = this.form.bitRate.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.bitRate = val
    },

    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

      async handlePreviewSharePic(file) {
          let suffix = file.name.substring(file.name.lastIndexOf('.'));
          if (suffix === '.mp4') {
              this.handleVideoPreview(file);
          } else {
              this.handleImagePreview(file);
          }
      },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },


      // 上传之前校验
      beforeOssUploadSharePic(file) {
          // const isJPG = file.type === 'image/jpeg';
          const isLt2M = file.size / 1024  < 20
          if (!isLt2M) {
              this.$message.error('上传图片大小不能超过 20K!')
          }
          return isLt2M
      },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'thumb'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
        _this.$set(_this.form, 'thumb', res)
      _this.$message.success(this.$t('通用.文本.上传成功'),)
    })
    })
    },

      coverImgUploadSharePic(file, index) {
          const _this = this
          // 获取文件对象
          const uploadFile = file.file
          // 文件夹目录
          const prefix = 'sharePic'
          const url = uploadOss(uploadFile.name, prefix)
          _this.$nextTick(() => {
              uploadObject(url, uploadFile).then(res => {
                  _this.$set(_this.form, 'sharePic', res)
                  _this.$message.success(this.$t('通用.文本.上传成功'),)
              })
          })
      },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'live'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
        _this.$set(_this.form, 'detailImg', res)
      _this.$message.success(this.$t('通用.文本.上传成功'),)
    })
    })
    },
    // oss 上传结束

    //选择商品
    indexGoodsModalSelect(records) {
      if (!records || records.length === 0) {
        return
      }
      // 标记商品类型，便于列表区分展示
      const list = records.map(item => Object.assign({}, item, {goodsType: 'seckill'}))
      if (this.form.id) {
        // 编辑已有直播：直接添加到直播间
        addSeckillGoodsToLiveRoom({liveId: this.form.id, seckillIds: list.map(e => e.id), recommend: 0}).then(() => {
          this.$message.success('添加秒杀商品成功')
          this.refreshLiveGoods()
        })
        return
      }
      // 新增直播：暂存，提交时作为秒杀商品ID提交
      this.form.goodsList = list
      // 如果有选中的商品，保存第一个商品的 ID（秒杀活动 ID）
      this.form.goodsId = list[0].id
      console.log('商品选择了', this.form.goodsList)
    },
    openProdSelect() {
      console.log('打开商品选择框,单选模式')
      this.$refs.RadioGoodsSelectForm.openGoods(undefined, [this.form.goodsId]);
    },
    //选择普通商品
    normalGoodsModalSelect(records) {
      if (!records || records.length === 0) {
        return
      }
      // 标记商品类型，便于列表区分展示
      const list = records.map(item => Object.assign({}, item, {goodsType: 'normal'}))
      if (this.form.id) {
        // 编辑已有直播：直接添加到直播间
        addLiveGoods({liveId: this.form.id, goodsIds: list.map(e => e.id).join(','), goodsType: 1}).then(() => {
          this.$message.success('添加普通商品成功')
          this.refreshLiveGoods()
        })
        return
      }
      // 新增直播：暂存，提交时作为普通商品提交
      this.form.normalGoodsList = list
      console.log('普通商品选择了', this.form.normalGoodsList)
    },
    openNormalProdSelect() {
      this.$refs.NormalGoodsSelectForm.openGoods()
    },
    // 刷新直播间已关联的商品
    refreshLiveGoods() {
      getLiveGoods({"id": this.form.id}).then(res => {
        this.form.goodsList = res.data || []
      })
    },
    //选择商品


    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    // getCategoryNameById(id) {
    //   if (!id) {
    //     return "";
    //   }
    //   let cateInfo = this.categoryList.find(e => e.id === id);
    //   if (cateInfo) {
    //     return cateInfo.categoryName
    //   } else {
    //     return "";
    //   }
    // },
    // getCateList() {
    //   listCategory().then(response => {
    //     this.categoryList = response.data;
    //   const cate = { id: "0", categoryName: this.$t('通用.文本.根节点'), children: [] }
    //   cate.children = this.handleTree(response.data, 'id','pid')
    //   this.cateOptions.push(cate)
    // })
    // },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
    })
    },
    //选择商品


    //查询店铺用户列表
    getShopUserList() {
      shopUserList().then(response => {
        this.shopUserList = response.data
    })
    },
      getUserList() {
          userList().then(response => {
        this.userList = response.data
    })
    },
    // 开播用户下拉搜索，按昵称/手机号模糊匹配
    filterUserOption(input, option) {
      if (!input) {
        return true
      }
      const keyword = input.trim().toLowerCase()
      // a-select-option 是组件，文本在 componentOptions.children 中
      const optionChildren = (option && option.componentOptions && option.componentOptions.children) || []
      let text = optionChildren.map(child => child.text || '').join('')
      if (!text) {
        // 兜底：取 option 的 title（昵称 + 手机号）
        const propsData = (option && option.componentOptions && option.componentOptions.propsData) || {}
        text = propsData.title || ''
      }
      return text.toLowerCase().indexOf(keyword) > -1
    },

    //查询可发放的优惠券(签到奖励)
    getSignCouponList() {
      listCouponType({}).then(response => {
        const list = response.data || []
        //过滤掉已过期的优惠券
        this.signCouponList = list.filter(item => {
          if (item.state === 1) {
            return false
          }
          //固定有效期优惠券,结束时间已过则不展示
          if (item.validType === 1 && item.endTime && new Date(item.endTime).getTime() < Date.now()) {
            return false
          }
          return true
        })
      })
    },

  }
}
</script>
